import axios from "axios";

const ChatService = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_CHAT_AI_ENDPOINT + "/api/v1/chat",
    headers: {
      "Content-Type": "application/json",
      "X-XSS-Protection": "X-XSS-Protection: 1; mode=block",
      "X-Frame-Options": "SAMEORIGIN",
      "Strict-Transport-Security": "max-age=10000000",
      "Content-Security-Policy": "default-src 'self'; child-src 'none';",
      "Referrer-Policy": "no-referrer",
      "X-Content-Type-Options": "nosniff",
      Authorization: "Bearer " + localStorage.getItem("localAuthorization"),
    },
  };

  let instance = axios.create(defaultOptions);

  return instance;
};

export default ChatService();

const fetchChatbotAnswer = async (payload) => {
  const res = await ChatService().post(`/ask`, payload);
  if (res.status === 200) {
    return res.data;
  }
};

export { fetchChatbotAnswer };
